export const enrollLearnersWizardText = {
  saveButton: 'Save',
  ModalHeader: 'Add Learners',
  DateHeading: 'Course Completion Date',
  DatePlaceholder: '(Optional)',
};
